import React from 'react';

import { AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import * as S from './style';

import { RowTextBold } from '../../common/Table/components';
import { FileDocumentList } from '../../../pages/student/Documents/components';
import {
  StyledAccordion,
  IDocumentData,
} from '../../../pages/student/Documents';
import { useTheme } from 'styled-components';

export default function AccordionDocuments({
  dataType,
}: {
  dataType: IDocumentData[] | [];
}) {
  const theme = useTheme();
  const structure = {
    Pendente: theme.colors?.warning,
    Rejeitado: theme.colors?.danger02,
    'Em Análise': theme.colors?.primary,
    Concluído: theme.colors?.text.success,
    Aprovado: theme.colors?.text.success,
  };

  return (
    <div style={{ marginBottom: '4rem' }}>
      {dataType &&
        dataType.map((item, index) => (
          <div key={item.id}>
            <StyledAccordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="accordion-content"
                id="accordion-header"
              >
                <S.AccordionSummary>
                  <S.AccordionSummary>
                    <RowTextBold>{item.name}</RowTextBold>
                    <RowTextBold color={structure[item.status]}>
                      {item.status}
                    </RowTextBold>
                  </S.AccordionSummary>
                  <div>
                    <RowTextBold>Abrir</RowTextBold>
                  </div>
                </S.AccordionSummary>
              </AccordionSummary>
              <AccordionDetails>
                <FileDocumentList
                  documentTypeId={dataType[index].id}
                  oldFiles={item.analysis}
                  canEdit={
                    item.status !== 'Aprovado' && item.status !== 'Concluído'
                  }
                />
              </AccordionDetails>
            </StyledAccordion>
          </div>
        ))}
    </div>
  );
}
